import { render, staticRenderFns } from "./ReadOnlyNoveltyItem.vue?vue&type=template&id=6c1749e3&"
import script from "./ReadOnlyNoveltyItem.vue?vue&type=script&lang=ts&"
export * from "./ReadOnlyNoveltyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports